"use client";

import React from "react";
import { IamUser, TenantDetailsByTenantIdRow } from "@guberno/data-access";

interface AppContextproviderProps {
  children: React.ReactNode;
  userData?: IamUser;
  appVersion?: string;
  appName?: string;
  //menuItems?: MenuItem[];
  tenantCompanyDetails?: TenantDetailsByTenantIdRow;
}

interface AppContextState {
  userData?: IamUser;
  enabledFeatures?: string[];
  appVersion?: string;
  //menuItems?: MenuItem[];
  tenantCompanyDetails?: TenantDetailsByTenantIdRow;
}

export interface ContextState {
  localAppState: AppContextState;
  setLocalAppState: React.Dispatch<React.SetStateAction<AppContextState>>;
  localAppName: string;
  localIsDrawerExpandedState: boolean;
  handleSetLocalIsDrawerExpandedState: (newState: boolean) => void;
}
export const AppContext = React.createContext<ContextState>({
  localAppState: {},
  localAppName: "",
  setLocalAppState: () => null,
  localIsDrawerExpandedState: true,
  handleSetLocalIsDrawerExpandedState: () => {},
});

export const AppContextProvider = (props: AppContextproviderProps) => {
  const { userData, tenantCompanyDetails, appVersion, appName } = props;
  const [localAppName] = React.useState<string>(appName);

  const [localAppState, setLocalAppState] = React.useState<AppContextState>({
    userData: userData,
    tenantCompanyDetails: tenantCompanyDetails,
    appVersion: appVersion,
  });

  const [localIsDrawerExpandedState, setLocalIsDrawerExpandedState] = React.useState<boolean>(true);

  React.useEffect(() => {
    const savedState = localStorage.getItem("FlatDrawer");
    if (savedState) {
      const parsed = JSON.parse(savedState);
      setLocalIsDrawerExpandedState(parsed.isDrawerExpanded);
    } else {
      localStorage.setItem("FlatDrawer", JSON.stringify({ isDrawerExpanded: true }));
      setLocalIsDrawerExpandedState(true);
    }
  }, []);

  const handleSetLocalIsDrawerExpandedState = (newState: boolean) => {
    setLocalIsDrawerExpandedState(newState);
    if (typeof window !== "undefined") {
      window.localStorage.setItem("FlatDrawer", JSON.stringify({ isDrawerExpanded: newState }));
    }
  };

  const context: ContextState = {
    localAppName,
    localAppState,
    setLocalAppState,
    localIsDrawerExpandedState,
    handleSetLocalIsDrawerExpandedState,
  };
  return <AppContext.Provider value={context}>{props.children}</AppContext.Provider>;
};
export default AppContextProvider;
